import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Toolbar,
  Box,
  IconButton,
  Divider,
} from "@mui/material";
import OrganizationIcon from "@mui/icons-material/AccountTree";
import UserIcon from "@mui/icons-material/Person";
// import MasterFileIcon from "@mui/icons-material/MenuBook";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../services/auth/AuthContext";
import Logo from "../../assets/logo.svg";

const drawerWidth = 240;

const sidebarItems = [
  // {
  //   label: "Dashboard",
  //   icon: <DashboardIcon />,
  //   to: "/dashboard",
  // },
  {
    label: "Organization",
    icon: <OrganizationIcon />,
    to: "/organisation",
  },
  {
    label: "User",
    icon: <UserIcon />,
    to: "/user",
  },
  // {
  //   label: "Master File",
  //   icon: <MasterFileIcon />,
  //   to: "/master-file",
  // },
];

interface SideBarProps {
  isOpen: boolean;
  closeSidebar: () => void;
}

const Sidebar: React.FC<SideBarProps> = ({ isOpen, closeSidebar }) => {
  const location = useLocation();
  const { user } = useAuth();
  
  // Determine if sidebar is temporary (mobile) or permanent (desktop)
  const isTemporary =
    typeof isOpen === "boolean" && typeof closeSidebar === "function";

  // Resolve role from possible shapes returned by auth
  const role =
    (user as any)?.role ??
    (user as any)?.data?.role ??
    (user as any)?.user?.role ??
    "";

  console.log('=== SIDEBAR DEBUG ===');
  console.log('User object:', user);
  console.log('Extracted role:', role);
  console.log('Role comparison:', role === "Super Admin");
  console.log('===================');

  // Role-based sidebar visibility logic
  const getVisibleItems = () => {
    if (role === "Super Admin") {
      // Super Admin can see both User and Organization
      return sidebarItems;
    } else {
      return sidebarItems.filter((item) => item.label === "Organization");
    }
  };
  
  const visibleItems = getVisibleItems();

  // const handleLogout = async () => {
  //   await logout();
  // };

  return (
    <Drawer
      variant={isTemporary ? "temporary" : "permanent"}
      open={isTemporary ? isOpen : undefined}
      onClose={isTemporary ? closeSidebar : undefined}
      className="sidebar-scrollbar"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
          overflowY: "auto",
        },
      }}
    >
      {/* Header with logo and close icon */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          pr: 1,
          pt: 1.5,
          pb: 0,
          pl: 1,
        }}
      >
        {isTemporary && (
          <IconButton onClick={closeSidebar} sx={{ color: "inherit", mr: 2 }}>
            <CloseIcon />
          </IconButton>
        )}
        <img
          src={Logo}
          alt="logo"
          style={{ width: "100px", height: "35px", cursor: "pointer" }}
        />
      </Box>
      <Divider sx={{ mt: 1 }} />
      <Toolbar />
      <List sx={{ width: "100%", p: 0, marginTop: "-50px" }}>
        {visibleItems.map((item) => (
          <ListItem  sx={{ width: "100%" }} key={item.label}>
            <ListItemButton
              component={Link}
              to={item.to}
              selected={location.pathname === item.to}
              onClick={isTemporary ? closeSidebar : undefined}
              sx={{
                minWidth: 40,
                width: "calc(100% - 16px)",
                margin: "0 8px",
                borderRadius: "8px",
                "&.Mui-selected": {
                  backgroundColor: "rgba(58, 42, 218, 0.08)",
                  "&:hover": {
                    backgroundColor: "rgba(58, 42, 218, 0.12)",
                  },
                  "& .MuiListItemText-primary": {
                    color: "#3A2ADA",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#3A2ADA",
                  },
                },
                "&:hover": {
                  backgroundColor: "rgba(58, 42, 218, 0.04)",
                  "& .MuiListItemText-primary": {
                    color: "inherit",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "inherit",
                  },
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
              <ListItemText
                primary={item.label}
                sx={{ "& .MuiListItemText-primary": { fontSize: "0.95rem" } }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      
    </Drawer>
  );
};

export default Sidebar;
